// Types
import {
	ACCOUNT_SUMMARY_REQUEST_START,
	ACCOUNT_SUMMARY_REQUEST_FAIL,
	ACCOUNT_SUMMARY_REQUEST_SUCCESS,
	ACCOUNT_COMMISSIONS_PENDING,
	ACCOUNT_COMMISSIONS_FAIL,
	ACCOUNT_COMMISSIONS_SUCCESS,
	ACCOUNT_COMMISSIONS_DATA_RESET,
} from './types';
import { CommissionViewType } from '../../../core/types/Series';
// Redux
import { affiliate, post } from './../session/actions';
import { getServicesErrorObj } from '../servicesDowntime/actions';
// Utils
import { convert, convertCommissions } from './utils/convert';
import { isArray } from 'lodash';

export const ACCOUNT_SUMMARY_URL: string = `/v1/affiliate-portal/affiliates/accountdetails`;
export const ACCOUNT_CUMULATIVE_GRAPH_DATA_URL: string = `/affiliate-portal/AffiliateDetails/commissions/getCumulativeAndGraphData`;

export const accountSummaryRequestStart = () => ({
	type: ACCOUNT_SUMMARY_REQUEST_START
});

export const accountSummaryRequestFail = () => ({
	type: ACCOUNT_SUMMARY_REQUEST_FAIL
});

export const accountSummaryRequestSuccess = (payload: any) => ({
	type: ACCOUNT_SUMMARY_REQUEST_SUCCESS,
	payload
});

export const getAccountSummary = (commissionViewType: CommissionViewType, translate: Function) => (
	dispatch: Function
) => new Promise((resolve, reject) => {
	dispatch(accountSummaryRequestStart());

	dispatch(
		post(ACCOUNT_SUMMARY_URL, {
			affiliate_number: [affiliate()]
		})
	).then((response: any) => {
		if (response && response.data) {
			const parsed: any = convert(response.data, commissionViewType, translate);
			dispatch(accountSummaryRequestSuccess(parsed));
			resolve(parsed);
		} else {
			dispatch(accountSummaryRequestFail());
		}
	}).catch((error: any) => {
		dispatch(accountSummaryRequestFail());
		dispatch(getServicesErrorObj(error));
		reject(error);
	});
});


/***********************/
// Commissions /START
/***********************/
export const accountCommisionsPending = () => ({
	type: ACCOUNT_COMMISSIONS_PENDING
});

export const accountCommisionsFail = () => ({
	type: ACCOUNT_COMMISSIONS_FAIL
});

export const accountCommisionsSuccess = (payload: any) => ({
	type: ACCOUNT_COMMISSIONS_SUCCESS,
	payload
});

export const accountCommissionsDataReset = () => ({
	type: ACCOUNT_COMMISSIONS_DATA_RESET
});

export const getAccountCommissions = (currentAffiliateIds: Array<string>, currency: string, view: string = 'generated') => (dispatch: Function) => new Promise((resolve, reject) => {
	dispatch(accountCommisionsPending());

	dispatch(
		post(ACCOUNT_CUMULATIVE_GRAPH_DATA_URL, {
			affiliate_number: Array.isArray(currentAffiliateIds) ? currentAffiliateIds[0] : currentAffiliateIds,
			currency
		}))
		.then((response: any) => {
			if (response && response.data) {
				const parsed: any = convertCommissions(response.data, view);
				setTimeout(function () {
					dispatch(accountCommisionsSuccess(parsed));
					resolve(parsed);
				}, 500);
			} else {
				dispatch(accountCommisionsFail());
				reject();
			}

		}).catch((error: any) => {
			dispatch(accountCommisionsFail());
			dispatch(getServicesErrorObj(error));
			reject(error);
		});
});

export type AccountSummaryAction = {
	type: string,
	payload?: any
};
